import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5 8.17a3.17 3.17 0 1 1 6.341 0A3.17 3.17 0 0 1 5 8.17ZM8.17 6.4a1.77 1.77 0 1 0 0 3.541 1.77 1.77 0 0 0 0-3.541Zm10.442-.93a.7.7 0 0 1 0 .99L6.46 18.612a.7.7 0 0 1-.99-.99L17.622 5.47a.7.7 0 0 1 .99 0Zm-5.953 10.36a3.17 3.17 0 1 1 6.34 0 3.17 3.17 0 0 1-6.34 0Zm3.17-1.771a1.77 1.77 0 1 0 0 3.54 1.77 1.77 0 0 0 0-3.54Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
